import { Component, OnInit } from '@angular/core';
import { ConteudoService } from '@core/services/conteudo.service';
import { ToastService } from '@modules/consulta/produtos/rnpa-pessoas/services/toast.service';
import { EmailMktService, IEmailBody } from '@modules/dashboard/services/email-mkt.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-dash-carrousel',
  templateUrl: './dash-carrousel.component.html',
  styleUrls: ['./dash-carrousel.component.scss']
})
export class DashCarrouselComponent implements OnInit {

  emailBody: IEmailBody = {
    interest: null,
    subject: null,
    segment: null,
    areaOfActivity: null,
    message: null
  }

  assuntos = ['Dúvida', 'Sugestão', 'Reclamação', 'Outro']
  segmentos = ['Automóvel', 'Diversos', 'Vida e Previdência', 'Patrimonial', 'Crédito e Garantia', 'Rural', 'Saúde', 'Capitalização']
  areasDeAtuacao = ['Subscrição', 'Precificação', 'Regulação de Sinistros', 'Prevenção à Fraude', 'Compliance', 'Tecnologia da Informação', 'Outra']

  slides = [];

  constructor(private nbgModalService: NgbModal, private _emailMktService: EmailMktService, private _toastService: ToastService, private _conteudoService: ConteudoService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this._conteudoService.buscarSlidersHome()
      .pipe(
        switchMap(slides =>
          Array.isArray(slides)
            ? this._conteudoService.buscarConteudosComImagens(slides)
            : of([])
        )
      )
      .subscribe({
        next: slidesComImagem => {
          this.slides = slidesComImagem;
        },
        error: erro => {
          console.error('Erro ao carregar slides', erro);
        }
      });
  }

  openModal(content) {
    this.nbgModalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'xl', windowClass: 'custom-modal email-modal' })
  }

  setEmailInterest(value: string) {
    this.emailBody.interest = value
  }

  sendEmail() {
    this._emailMktService.sendEmail(this.emailBody).subscribe((res) => {
      this._toastService.showSuccess("Mensagem enviada! Em breve, um membro de nossa equipe entrará em contato.")
      this.nbgModalService.dismissAll('Success!')
      this.resetEmailBody()
    }, err => {
      this._toastService.showError("Não foi possível concluir o envio.")
    })
  }

  resetEmailBody() {
    this.emailBody = {
      interest: null,
      subject: null,
      segment: null,
      areaOfActivity: null,
      message: null
    }
  }

}
